import {
  showUploadStatus,
  setSourceUploadStatus
} from '@shoflo/studio-redux/actions';
import { withCurrentParams, handleDocumentUpload } from 'actions/utils';
import { BROADCAST_UPDATE_CONTENT_SOURCE } from '@shoflo/studio-redux/actions/types';
import { UPLOADING } from 'constants/SourceUploadStatus';
import onFailedUpload from './onFailedUpload';
import { SOURCE_MAX_FILE_SIZE_MULTIPART } from '@shoflo/polymer';
import { isVideoSource } from 'utils/broadcastSourceHelper';
import { handleMultipartUpload } from '@shoflo/studio-redux/utils';

/**
 * This function supports uploads only via S3 Proxy service.
 * Any changes in the upload functionality triggered from {@link MEDIA_SOURCE_FORM} Modal
 * opened by clicking Upload Content should be handled here.
 * @param {*} sourceId - Source ID of the content placeholder where the content is placed or uploaded
 * @param {*} changes  - Data that should be updated for the given sourceId
 * @param {*} file      - Actual file to be uploaded
 * @param {*} fileUploadActionTracker - Functions to track file upload action
 */
const updateContentSource = (
  sourceId,
  changes,
  file,
  fileUploadActionTracker
) => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_UPDATE_CONTENT_SOURCE,
      request: async apiClient => {
        // If it's a doc type, we need to create a new event doc so we can assign it as the value
        const { name: fileName = '' } = file;
        dispatch(setSourceUploadStatus(fileName, UPLOADING));
        dispatch(showUploadStatus());

        const isMultiPartUpload =
          isVideoSource(changes) && file.size > SOURCE_MAX_FILE_SIZE_MULTIPART;

        const createDocPayload = {
          name: fileName,
          description: 'Media Content',
          isStudioMedia: true,
          isMultipartUpload: isMultiPartUpload
        };
        const onFailedUploadCallback = onFailedUpload(dispatch, fileName);
        try {
          // If the file is a video and the size is greater than 40 MB, use multi-part upload
          if (isMultiPartUpload) {
            const uploadResponse = await handleMultipartUpload(
              apiClient,
              teamId,
              eventId,
              createDocPayload,
              file,
              fileUploadActionTracker.startFileUploadActionCallback
            );
            changes.value = uploadResponse.eventDocId;
          } else {
            // For non-multipart uploads, we handle the document upload via S3 Proxy service
            const _id = await handleDocumentUpload(
              apiClient,
              teamId,
              eventId,
              createDocPayload,
              file,
              fileUploadActionTracker.startFileUploadActionCallback
            );
            changes.value = _id;
          }

          let result = await apiClient.broadcast.updateSource(
            teamId,
            eventId,
            broadcastId,
            sourceId,
            changes
          );
          // End file upload action tracker
          fileUploadActionTracker.endFileUploadActionCallback?.({});
          return result;
        } catch (error) {
          console.error('Failed while uploading the file' + error);
          fileUploadActionTracker.endFileUploadActionCallback?.({
            errorMessage: error.message
          });
          onFailedUploadCallback();
        }
      }
    };
    dispatch(action);
  });
};

export default updateContentSource;
